import _ from 'lodash';
import { getDateByShortcut } from './date';

export const trimObjectProps = <T extends {}>(obj: T) => {
  let o = _.clone(obj);

  Object.entries(obj).forEach(([key, val]) => {
    if (val === '' || val === null) {
      //@ts-ignore
      o[key] = undefined;
    }
  });

  return o;
};

export const tranformSearchFiltersForBE = <T extends {}>(filters: T): T => {
  let fromDateLong = undefined;
  let toDateLong = undefined;
  const filtersWithDateShortcut = filters as T & FiltersWithDateShortcut;
  if (filtersWithDateShortcut.dateShortcut && filtersWithDateShortcut.dateShortcut === '1w+') {
    toDateLong = getDateByShortcut('1w').getTime();
    fromDateLong = null;
  } else {
    if ((filters as any).dateShortcut !== undefined && (filters as any).dateShortcut !== 'custom') {
      const date = new Date();
      fromDateLong = getDateByShortcut((filters as any).dateShortcut).getTime();
      toDateLong = date.getTime();
    } else {
      if ((filters as any)?.from) {
        fromDateLong = new Date((filters as any).from).getTime();
      }
      if ((filters as any)?.to) {
        toDateLong = new Date((filters as any).to).getTime();
      }
    }
  }

  return trimObjectProps<T>({ ...filters, from: fromDateLong, to: toDateLong } as T);
};

type FiltersWithDateShortcut = {
  dateShortcut?: string;
};